import { defineMessages } from 'react-intl-next';

export const i18n: {
	macroLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unableToRender: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	notFound: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	alreadyIncluded: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	invalidContentType: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	genericError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	macroLabel: {
		id: 'page-include-macro.label',
		defaultMessage: 'Include Page',
		description: 'Label for the Include Page macro',
	},
	unableToRender: {
		id: 'page-include-macro.unable-to-render',
		defaultMessage: 'Unable to render include',
		description: 'Error heading shown when the include macro cannot render',
	},
	notFound: {
		id: 'page-include-macro.error.not-found',
		defaultMessage: 'The included page could not be found.',
		description:
			'Error message shown when the included page does not exist or the viewer lacks permission',
	},
	alreadyIncluded: {
		id: 'page-include-macro.error.already-included',
		defaultMessage: 'Already included page \u201c{pageTitle}\u201d, stopping.',
		description:
			'Error message shown when a circular page inclusion is detected. pageTitle is the title of the already-included page.',
	},
	noTitle: {
		id: 'page-include-macro.error.no-title',
		defaultMessage: 'No title provided.',
		description: 'Error message shown when the include macro has no target configured',
	},
	invalidContentType: {
		id: 'page-include-macro.error.invalid-content-type',
		defaultMessage: 'You can only link to a page or blog post.',
		description: 'Error message shown when the include target is not a page or blog post',
	},
	loading: {
		id: 'page-include-macro.loading',
		defaultMessage: 'Loading included page\u2026',
		description: 'Accessible loading label for the include macro spinner',
	},
	genericError: {
		id: 'page-include-macro.error.generic',
		defaultMessage: 'Unable to render include',
		description: 'Generic error fallback for the include macro error boundary',
	},
});
